import { getBusinessDateString, parseBusinessDate } from '@vista/omnichannel-components-domain';
import { max, min } from 'date-fns';
export var ScreeningDateType;
(function (ScreeningDateType) {
    ScreeningDateType["Next"] = "Next";
    ScreeningDateType["Previous"] = "Previous";
})(ScreeningDateType || (ScreeningDateType = {}));
export const getNextOrPreviousScreeningDate = (selectedBusinessDate, screeningDates, filmId, siteId) => {
    if (!selectedBusinessDate || !screeningDates)
        return undefined;
    const futureScreeningDates = [];
    const pastScreeningDates = [];
    screeningDates.forEach(screeningDate => {
        const businessDate = parseBusinessDate(screeningDate.businessDate);
        if (!screeningDateContainsFilmAndSite(screeningDate, filmId, siteId)) {
            return;
        }
        if (screeningDate.businessDate > selectedBusinessDate) {
            futureScreeningDates.push(businessDate);
        }
        else if (screeningDate.businessDate < selectedBusinessDate) {
            pastScreeningDates.push(businessDate);
        }
    });
    if (futureScreeningDates.length) {
        const nextBusinessDate = min(futureScreeningDates);
        return {
            type: ScreeningDateType.Next,
            screeningDate: getBusinessDateString(nextBusinessDate)
        };
    }
    if (pastScreeningDates.length) {
        const prevBusinessDate = max(pastScreeningDates);
        return {
            type: ScreeningDateType.Previous,
            screeningDate: getBusinessDateString(prevBusinessDate)
        };
    }
};
const screeningDateContainsFilmAndSite = (screeningDate, filmId, siteId) => {
    return (screeningDate.filmScreenings.find(screening => screening.filmId === filmId && screening.sites.find(site => site.siteId === siteId)) !== undefined);
};
